export default {"src":"/_next/static/media/address.206828e9.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};